export const contentTableConfig = {
  title: '加盟商列表',
  propList: [
    { prop: 'name', label: '加盟者名称', minWidth: '120' },
    { prop: 'phone', label: '电话', minWidth: '120' },
    { prop: 'city', label: '城市', minWidth: '100' },
    { prop: 'industry', label: '行业', minWidth: '120' },
    { prop: 'fund', label: '预投资金', minWidth: '120' },
    { prop: 'createTime', label: '创建时间', minWidth: '160' }
  ],
  showSelectColumn: false
} 